import { Button as OriginalButton } from 'antd';

export const Button: any = OriginalButton;
